export const atofflineDeData = {
  title: 'Datenschutz- und Cookie-Richtlinie – Danghuan',
  sections: [
    {
      title: 'Einleitung',
      content: `
        <p>Diese Datenschutz- und Cookie-Richtlinie erläutert, wie Danghuan Europe S.L. ("wir", "uns" oder "Danghuan") Ihre personenbezogenen Daten erhebt, verwendet und schützt, wenn Sie mit unseren Websites und Diensten interagieren. Diese Richtlinie gilt für Einwohner des Europäischen Wirtschaftsraums (EWR) und erfüllt die Anforderungen der Datenschutz-Grundverordnung (DSGVO) sowie des Bundesdatenschutzgesetzes (BDSG).</p>
      `
    },
    {
      title: 'Geltungsbereich dieser Richtlinie',
      content: `
        <p>Diese Richtlinie gilt für:</p>
        <ul>
          <li>Besucher unserer Website (https://www.danghuan.eu)</li>
          <li>Kunden und potenzielle Kunden</li>
          <li>Nutzer unserer Trade-In- und Wiederverkaufsdienste</li>
          <li>Vertreter von Geschäftspartnern und Plattform-Partnerunternehmen</li>
        </ul>
      `
    },
    {
      title: 'Welche Daten wir erheben',
      content: `
        <p>Je nach Art Ihrer Interaktion mit uns können wir folgende personenbezogene Daten erheben:</p>
        <ul>
          <li>Vollständiger Name, Anschrift, E-Mail-Adresse und Telefonnummer</li>
          <li>IBAN, Sort Code und Kontonummer, PayPal-, Revolut- oder andere Bankverbindungsdaten</li>
          <li>Gerätedetails (Modell, Marke, Zustand, Preisinformationen, Seriennummer, IMEI)</li>
          <li>Kommunikationsverlauf mit dem Kundendienst</li>
          <li>Marketingpräferenzen und Interaktionen mit Kampagnen</li>
          <li>IP-Adresse, Browsertyp, Sitzungs-ID und Standort</li>
          <li>Plattformdaten von Shopify, Amazon, TEMU, Back Market</li>
        </ul>
        <p>Wir können bestimmte Daten auch über unsere Plattform- oder Logistikpartner (z. B. Shopify, Amazon, Back Market, TEMU) erhalten, wenn Sie über deren Plattformen mit unseren Diensten interagieren. Diese Daten können Bestellinformationen, Versandadressen und Transaktionsstatus umfassen.</p>
      `
    },
    {
      title: 'Verwendung personenbezogener Daten',
      content: `
        <p>Wir verwenden Ihre personenbezogenen Daten, um die folgenden Zwecke zu erfüllen:</p>
        <ul>
          <li>Bearbeitung von Bestellungen und Verwaltung der Logistik, einschließlich Rücksendungen und Trade-In-Prozesse</li>
          <li>Kommunikation mit Ihnen in Bezug auf Ihre Transaktionen und Serviceanfragen</li>
          <li>Bereitstellung von Kundendienst und technischem Support</li>
          <li>Versand von Marketingmitteilungen (sofern Sie dem ausdrücklich zugestimmt haben)</li>
          <li>Einhaltung gesetzlicher Verpflichtungen, z. B. Steuer-, Buchhaltungs- oder Betrugsprüfungen</li>
          <li>Verbesserung der Benutzererfahrung und Optimierung unserer Plattformen und Services</li>
        </ul>
      `
    },
    {
      title: 'Cookies',
      content: `
        <p>Wir verwenden Cookies, um Ihr Browser-Erlebnis zu verbessern und unsere Dienste zu optimieren. Cookies können folgende Informationen erfassen:</p>
        <ul>
          <li>IP-Adresse und Geolokalisierung</li>
          <li>Browser- oder Gerätekennungen</li>
          <li>Nutzungsverhalten (z. B. besuchte Seiten, Verweildauer, Klicks)</li>
        </ul>
        <p>Arten von Cookies:</p>
        <ul>
          <li>Strikt erforderliche Cookies</li>
          <li>Funktionale Cookies</li>
          <li>Leistungs- / Performance-Cookies</li>
          <li>Werbe- / Targeting-Cookies</li>
        </ul>
        <p>Sie können Ihre Cookie-Einstellungen jederzeit über die Einstellungen Ihres Browsers oder über das Cookie-Banner auf unserer Website anpassen oder widerrufen.</p>
      `
    },
    {
      title: 'Weitergabe an Dritte',
      content: `
        <p>Wir geben Daten nur an Dritte weiter, soweit dies zur Vertragserfüllung erforderlich oder von Ihrer Einwilligung gedeckt ist.</p>
        <p>Empfänger können sein:</p>
        <ul>
          <li>Zahlungspartner: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li>Logistikdienstleister: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li>Plattformpartner: Shopify, Amazon, TEMU, Back Market</li>
          <li>Marketing- und Analysepartner: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li>IT-Dienstleister, Berater und Rechtsanwälte</li>
          <li>Behörden, sofern gesetzlich vorgeschrieben</li>
        </ul>
        <p>Datenübermittlungen außerhalb des Europäischen Wirtschaftsraums (EWR) erfolgen ausschließlich unter Einhaltung geeigneter Garantien gemäß Art. 46 DSGVO, insbesondere auf Grundlage der von der Europäischen Kommission genehmigten Standardvertragsklauseln.</p>
      `
    },
    {
      title: 'Verwendung von Marken und Logos Dritter',
      content: `
        <p>Unsere Website zeigt Marken und Logos (z. B. Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google, Inst360 u. a.) ausschließlich zur Identifikation kompatibler Geräte für Trade-In- oder Wiederverkaufszwecke. Alle Marken gehören ihren jeweiligen Eigentümern. Danghuan Europe ist ein unabhängiger Dienstleister, nicht mit diesen Marken verbunden und weder autorisiert noch gesponsert, außer wenn ausdrücklich angegeben.</p>
        <p>Die Darstellung der Logos dient allein beschreibenden Zwecken; sämtliche Markenrechte verbleiben bei den jeweiligen Inhabern.</p>
      `
    },
    {
      title: 'Datenspeicherung und Sicherheit',
      content: `
        <p>Wir speichern Ihre Daten nur so lange, wie es zur Erfüllung der oben genannten Zwecke oder gesetzlich erforderlich ist. Wir treffen geeignete technische und organisatorische Maßnahmen zum Schutz Ihrer Daten – einschließlich Verschlüsselung, Zugriffskontrolle und sicherer Speicherung.</p>
      `
    },
    {
      title: 'Ihre Rechte',
      content: `
        <p>Wir beantworten berechtigte Anfragen innerhalb eines Monats. Zum Schutz Ihrer Privatsphäre müssen wir ggf. Ihre Identität verifizieren.</p>
        <p>Sie haben das Recht:</p>
        <ul>
          <li>auf Auskunft und Berichtigung Ihrer Daten</li>
          <li>auf Löschung ("Recht auf Vergessenwerden")</li>
          <li>der Verarbeitung zu widersprechen oder sie einzuschränken</li>
          <li>Ihre Einwilligung jederzeit zu widerrufen</li>
          <li>die Datenübertragbarkeit zu verlangen (soweit anwendbar)</li>
        </ul>
        <p>Zur Ausübung dieser Rechte kontaktieren Sie uns bitte unter: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a>.</p>
      `
    },
    {
      title: 'Aktualisierungen dieser Richtlinie',
      content: `
        <p>Wir können diese Richtlinie anpassen, um Änderungen rechtlicher Anforderungen oder interner Datenpraktiken widerzuspiegeln. Die jeweils aktuelle Version finden Sie jederzeit auf unserer Website.</p>
      `
    },
    {
      title: 'Kontakt',
      content: `
        <p>Bei Fragen oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an:</p>
        <ul>
          <li>Danghuan Europe S.L.</li>
          <li>Email: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li>Website: <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>Sie können außerdem eine Beschwerde bei Ihrer zuständigen nationalen Datenschutzaufsichtsbehörde oder beim Bundesbeauftragten für den Datenschutz und die Informationsfreiheit (BfDI) einreichen.</p>
      `
    },
    {
      title: 'Anhang – Erweiterte rechtliche und Cookie-Informationen',
      subsections: [
        {
          title: '1. Rechtsgrundlagen der Datenverarbeitung',
          content: `
            <p>Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Basis von:</p>
            <ul>
              <li>Vertragserfüllung (z. B. Bearbeitung von Trade-In-Bestellungen, Zahlungsabwicklung)</li>
              <li>Gesetzlichen Pflichten (z. B. Steuer- oder Identitätsprüfung)</li>
              <li>Einwilligung (z. B. für Marketingkommunikation oder Cookies von Dritten)</li>
              <li>Berechtigtem Interesse (z. B. Betrugsprävention, interne Analysen, Serviceverbesserung)</li>
            </ul>
          `
        },
        {
          title: '2. Betrugsprävention',
          content: `
            <p>Wir können personenbezogene Informationen (z. B. Seriennummer, Transaktionsmuster, IP-Geolokation, IBAN-Inhaberschaft) zur Betrugserkennung mithilfe öffentlicher Datenbanken und Anti-Betrugs-Dienstleister nutzen. Dies erfolgt auf Grundlage unseres berechtigten Interesses, Identitätsdiebstahl und Missbrauch unserer Dienste zu verhindern.</p>
            <p>Es werden keine Entscheidungen ausschließlich auf automatisierter Verarbeitung getroffen, die rechtliche Wirkungen entfalten oder Sie in vergleichbarer Weise erheblich beeinträchtigen.</p>
          `
        },
        {
          title: '3. Datenverarbeitung auf externen Marktplätzen',
          content: `
            <p>Wenn Sie Geräte über Drittplattformen wie Amazon, Shopify, TEMU oder Back Market kaufen oder verkaufen, kann Danghuan Ihre Bestellinformationen, Versandadresse und Zahlungsbestätigung über verschlüsselte Schnittstellen (API) oder sichere Back-Office-Kanäle erhalten – ausschließlich zur Vertragsabwicklung und After-Sales-Unterstützung.</p>
          `
        },
        {
          title: '4. Cookie-Kategorien und Details',
          content: `
            <p>Eine vollständige Liste der von uns verwendeten Cookies – einschließlich Name, Anbieter, Zweck, Speicherdauer und Typ (Eigene oder Drittanbieter-Cookies) – finden Sie in der nachstehenden Tabelle. Dazu gehören Analyse-Cookies von Google Analytics, Retargeting-Cookies von Meta, sowie Zahlungs-Cookies von PayPal.</p>
            <table>
              <thead>
                <tr>
                  <th>Kategorie</th>
                  <th>Cookie-Name</th>
                  <th>Anbieter</th>
                  <th>Zweck</th>
                  <th>Speicherdauer</th>
                  <th>Typ</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Strikt erforderlich</td>
                  <td>OptanonConsent</td>
                  <td>danghuan.eu</td>
                  <td>Speichert Cookie-Einstellungen</td>
                  <td>1 Jahr</td>
                  <td>Erstanbieter</td>
                </tr>
                <tr>
                  <td>Strikt erforderlich</td>
                  <td>session_id</td>
                  <td>danghuan.eu</td>
                  <td>Behält Sitzungsstatus über Seiten hinweg</td>
                  <td>Session</td>
                  <td>Erstanbieter</td>
                </tr>
                <tr>
                  <td>Funktional</td>
                  <td>i18next</td>
                  <td>danghuan.eu</td>
                  <td>Merkt ausgewählte Spracheinstellung</td>
                  <td>Session</td>
                  <td>Erstanbieter</td>
                </tr>
                <tr>
                  <td>Funktional</td>
                  <td>live_chat</td>
                  <td>Tawk.to</td>
                  <td>Ermöglicht Live-Chat-Support</td>
                  <td>6 Monate</td>
                  <td>Drittanbieter</td>
                </tr>
                <tr>
                  <td>Performance</td>
                  <td>_ga</td>
                  <td>Google Analytics</td>
                  <td>Sammelt Statistiken zur Websitenutzung</td>
                  <td>2 Jahre</td>
                  <td>Drittanbieter</td>
                </tr>
                <tr>
                  <td>Performance</td>
                  <td>_gid</td>
                  <td>Google Analytics</td>
                  <td>Verfolgt Nutzerverhalten über Sitzungen hinweg</td>
                  <td>24 Stunden</td>
                  <td>Drittanbieter</td>
                </tr>
                <tr>
                  <td>Performance</td>
                  <td>_clck</td>
                  <td>Microsoft Clarity</td>
                  <td>Behält Nutzersitzung über Seiten hinweg bei</td>
                  <td>1 Jahr</td>
                  <td>Drittanbieter</td>
                </tr>
                <tr>
                  <td>Advertising</td>
                  <td>_fbp</td>
                  <td>Meta (Facebook)</td>
                  <td>Liefert personalisierte Werbung basierend auf Verhalten</td>
                  <td>3 Monate</td>
                  <td>Drittanbieter</td>
                </tr>
                <tr>
                  <td>Advertising</td>
                  <td>_tt_enable_cookie</td>
                  <td>TikTok</td>
                  <td>Verfolgt Nutzerinteraktionen und Conversions</td>
                  <td>13 Monate</td>
                  <td>Drittanbieter</td>
                </tr>
                <tr>
                  <td>Advertising</td>
                  <td>_uetsid</td>
                  <td>Bing</td>
                  <td>Verfolgt Nutzer über Websites hinweg für Marketing</td>
                  <td>1 Tag</td>
                  <td>Drittanbieter</td>
                </tr>
                <tr>
                  <td>Advertising</td>
                  <td>_gcl_au</td>
                  <td>Google Ads</td>
                  <td>Wird für Conversion-Tracking verwendet</td>
                  <td>3 Monate</td>
                  <td>Drittanbieter</td>
                </tr>
                <tr>
                  <td>Advertising</td>
                  <td>__kla_id</td>
                  <td>Klaviyo</td>
                  <td>Identifiziert Besucher für E-Mail-Marketingkampagnen</td>
                  <td>2 Jahre</td>
                  <td>Drittanbieter</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: '5. Aktionen, Kampagnen und Umfragen',
          content: `
            <p>Wenn Sie an unseren Aktionen, Umfragen oder Gewinnspielen teilnehmen, erheben wir ggf. Ihren Namen, Kontaktdaten und weitere veranstaltungsspezifische Informationen (z. B. Alter, Standort). Diese Daten werden ausschließlich zur Durchführung der Aktion, zur Kontaktaufnahme mit Gewinnern und zur Optimierung zukünftiger Kampagnen verwendet.</p>
          `
        },
        {
          title: '6. Aufsichtsbehörden',
          content: `
            <p>Wenn Sie der Ansicht sind, dass Ihre Datenschutzrechte verletzt wurden, können Sie eine Beschwerde einreichen bei:</p>
            <ul>
              <li>In Deutschland: Der Bundesbeauftragte für den Datenschutz und die Informationsfreiheit (BfDI) – <a href="https://www.bfdi.bund.de" target="_blank">https://www.bfdi.bund.de</a></li>
              <li>In der Europäischen Union: die zuständige nationale Aufsichtsbehörde Ihres Landes über die Website des European Data Protection Board (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ],
  footer: `
    <p>© 2025 DANGHUAN EUROPE S.L. Alle Rechte vorbehalten.<br>
    Richtlinienversion: v1.0 | Letzte Aktualisierung: 30.05.2025</p>
  `
};